$(document).ready(
    function () {
        $("a.fancybox").fancybox(
            {
                padding: 0,
                helpers: {
                    overlay: {
                        css: {
                            'background': 'rgba(0, 0, 0, 0.9)'
                        },
                        closeClick: false
                    }
                },
                afterShow: function () {
                    $('.fancybox-wrap').swipe({
                        swipe: function (event, direction) {
                            if (direction === 'left' || direction === 'up') {
                                $.fancybox.next(direction);
                            } else {
                                $.fancybox.prev(direction);
                            }
                        }
                    });
                },
                tpl: {
                    next: '<a title="Volgende" class="fancybox-nav fancybox-next" href="javascript:;"><span><i class="icon icon-chevron-thin-right"></i></span></a>',
                    prev: '<a title="Vorige" class="fancybox-nav fancybox-prev" href="javascript:;"><span><i class="icon icon-chevron-thin-left"></i></span></a>',
                    closeBtn: '<a title="Sluiten" class="fancybox-item fancybox-close myClose" href="javascript:;"><i class="icon icon-window-close"></i></a>'
                },
                beforeShow: function () {
                    this.title = this.title + " <span class='small'>" + $(this.element).data("caption") + "</span>";

                    var imgAlt = $(this.element).find("img").attr("alt");
                    var dataAlt = $(this.element).data("alt");
                    if (imgAlt) {
                        $(".fancybox-image").attr("alt", imgAlt);
                    } else if (dataAlt) {
                        $(".fancybox-image").attr("alt", dataAlt);
                    }
                }
            }
        );

        $('body').on('touchstart', '.fancybox-overlay', function (e) {
            e.preventDefault();
        });
    }
);